const dismissedContentCardIds = new Set<string>();

export const isDismissedContentCardId = (
  id: string | undefined | null,
): boolean => {
  return id ? dismissedContentCardIds.has(id) : false;
};

export const markContentCardDismissed = (id: string): void => {
  dismissedContentCardIds.add(id);
};
